import React, { useEffect, useState } from 'react';
import fetch from '../Utils/fetch';
import { useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../store/alert';
import { addProducts } from '../../store/products';
import Searchbar from '../Components/searchbar';
import ProductSlider from '../Products/ProductSlider';
import Universalheader from '../Headers/universalheader';
import { Button, CircularProgress, Skeleton } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import MobileCategorySection from '../Home/MobileCategorySection';



const Allcategories = () => {
	useDocumentTitle('Products & Services');

	const navigate = useNavigate()
	const categories = useSelector((state) => state.categories.data);
	const [showsearchbar, setshowsearchbar] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);


	return (
		<div className="homebody">
			{showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={[]} />}
			<Universalheader onshowsearchbar={() => setshowsearchbar(true)} />
			
			<div className="allcategoriescontent">
				{categories && categories.length > 0 ? (
					categories.map((category) => (
						<MobileCategorySection key={category.item_group} category={category} />
					))
				) : (
					<div>
						{Array.from({ length: 15 }, (_, index) => (
							<div key={index} style={{ marginBottom: 20 }}>
								<Skeleton variant="rectangular" sx={{ height: 40, width: '90%', marginLeft: 2, marginBottom: 1 }} />
								<div style={{ display: 'flex', overflow: 'hidden', padding: '0 10px' }}>
									{Array.from({ length: 4 }, (_, i) => (
										<Skeleton key={i} variant="rectangular" sx={{ height: 180, width: 140, margin: 1, borderRadius: 2 }} />
									))}
								</div>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
}

export default Allcategories